const monthFormatter = new Intl.DateTimeFormat('ru-RU', { day: 'numeric', month: 'long', timeZone: 'UTC' });
const weekdayFormatter = new Intl.DateTimeFormat('ru-RU', { weekday: 'long', timeZone: 'UTC' });

// Date-only values retain their calendar day regardless of the browser's timezone.
export function formatDateTooltip(value) {
    if (Array.isArray(value)) {
        const [start, end] = value.map(formatDateTooltip);
        return value.length === 2 && start && end ? `С ${start} по ${end}` : '';
    }
    if (typeof value !== 'string') return '';
    const text = value.trim();
    const iso = /^(\d{4})-(\d{2})-(\d{2})(?:T.*)?$/.exec(text);
    const displayed = /^(\d{2})\.(\d{2})\.(\d{4})$/.exec(text);
    if (!iso && !displayed) return '';
    const [year, month, day] = iso ? iso.slice(1).map(Number) : [Number(displayed[3]), Number(displayed[2]), Number(displayed[1])];
    const date = new Date(0);
    date.setUTCFullYear(year, month - 1, day);
    if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return '';
    return `${monthFormatter.format(date)} ${year} года · ${weekdayFormatter.format(date)}`;
}
